/* ==========================================================================
   CRKD*arthouse — universal app shell behaviour
   1. mounts page inspector / status into the shared chrome
   2. grid + rulers (landing-page drawing code, verbatim, + scroll offset)
   3. global mouse tracking (X / Y readouts)
   4. Swatches — light/dark mode + highlight colour
   5. Drawing tools — brush, eraser, shapes, marquees (cut), type, eyedropper
   ========================================================================== */
(function () {
  'use strict';
  if (window.__crkdShell) return; window.__crkdShell = true;

  var doc = document, root = doc.documentElement;
  function $(s, r) { return (r || doc).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); }
  function store(kind) { try { return window[kind]; } catch (e) { return null; } }
  function sget(kind, k) { try { var s = store(kind); return s ? s.getItem(k) : null; } catch (e) { return null; } }
  function sset(kind, k, v) { try { var s = store(kind); if (s) s.setItem(k, v); } catch (e) {} }
  function sdel(kind, k) { try { var s = store(kind); if (s) s.removeItem(k); } catch (e) {} }

  var DEFAULT_HL = '#ff2d78';
  var isTyping = function (el) {
    el = el || doc.activeElement;
    if (!el) return false;
    var t = (el.tagName || '').toLowerCase();
    return t === 'input' || t === 'textarea' || t === 'select' || el.isContentEditable;
  };

  function boot() {
    root.classList.add('cx-on');
    var grid = $('.cx-grid'), dood = $('.cx-doodle');
    if (!grid || !dood) return;

    /* ------------------------------------------------------------------
       1. mount page-specific inspector + status
       ------------------------------------------------------------------ */
    var secInsp = $('[id^="crkd-"] .app > .insp');
    var insp = secInsp || $('.cx-insp');
    if (secInsp) root.classList.add('cx-has-insp');

    var secStatus = $('[id^="crkd-"] .app > .status');
    if (secStatus) {
      var slot = $('.cx-status-page');
      // page-specific status items (Dir / Series / Reach…) — skip the ones the shell already shows
      $$('.s', secStatus).forEach(function (s) {
        if ($('.j-sX,.j-sY', s) || /^\s*(X|Y|Zoom|Tool)\b/.test(s.textContent)) return;
        slot.appendChild(s); });
      var sd = $('.doc', secStatus);
      if (sd && sd.textContent.trim()) $('.cx-doc').textContent = sd.textContent.trim();
    }

    /* Swatches panel goes directly under Properties */
    var tpl = $('#cx-swatches-tpl');
    var sw = tpl.content.firstElementChild.cloneNode(true);
    var props = null;
    $$('.pnl', insp).forEach(function (p) { var h = $('h4', p); if (h && /^\s*properties\s*$/i.test(h.textContent)) props = p; });
    var typeRow = $('#cx-type-tpl').content.firstElementChild.cloneNode(true);
    if (props) (props.querySelector('.props') || props).appendChild(typeRow); else sw.insertBefore(typeRow, sw.children[1]);
    if (props && props.nextSibling) insp.insertBefore(sw, props.nextSibling);
    else if (props) insp.appendChild(sw);
    else insp.appendChild(sw);
    // the landing page shipped its own (now superseded) swatch block
    $$('.pnl', insp).forEach(function (p) { if (p !== sw && $('.swatches', p)) p.parentNode.removeChild(p); });

    /* Layers panel — the eye toggles the layer, clicking the row selects it */
    $$('[data-cx-layer]').forEach(function (row) {
      var eye = $('.eye', row), sec = row.closest('[id^="crkd-"]') || doc, tgt = row.getAttribute('data-cx-layer');
      if (!eye) return;
      var slash = doc.createElementNS('http://www.w3.org/2000/svg', 'path');
      slash.setAttribute('d', 'M1.5 10.5l9-9'); slash.setAttribute('stroke', 'currentColor'); slash.setAttribute('stroke-width', '1.1');
      slash.setAttribute('class', 'cx-slash'); eye.appendChild(slash);
      function toggle(e) { e.preventDefault(); e.stopPropagation();
        var off = row.classList.toggle('off'); eye.setAttribute('aria-pressed', off ? 'false' : 'true');
        if (tgt === 'grid') root.classList.toggle('cx-nogrid', off);
        else $$(tgt, sec).forEach(function (el) { el.style.visibility = off ? 'hidden' : ''; }); }
      eye.addEventListener('click', toggle);
      eye.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') toggle(e); });
      row.addEventListener('click', function () { $$('.layer', row.parentNode).forEach(function (r) { r.classList.toggle('sel', r === row); }); });
    });

    /* ------------------------------------------------------------------
       2. grid + rulers — sections/crkdlanding.liquid draw(), verbatim,
          with the grid/labels following scrollY
       ------------------------------------------------------------------ */
    var ctx = grid.getContext('2d');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var W, H, mx = -1, my = -1, t = 0;
    var UNIT = 40, SUB = 10, SUBDIVS = 4;
    function mod(a, n) { return ((a % n) + n) % n; }
    function resizeGrid() { W = grid.offsetWidth; H = grid.offsetHeight; grid.width = W; grid.height = H; }
    function hlRGB() { return window.CRKD_HL_RGB || '255,45,120'; }
    var FG = '255,255,255';
    function readFG() { var v = getComputedStyle(root).getPropertyValue('--cx-fg').trim(); FG = v || '255,255,255'; gridDirty = true; }
    function draw() {
      var sy = window.scrollY || 0;
      ctx.clearRect(0, 0, W, H);
      var ox = (t * 8) % UNIT, oy = (t * 5) % UNIT;
      var baseY = mod(H / 2 - sy, UNIT);
      for (var x = -UNIT + (W / 2 % UNIT) - ox; x < W + UNIT; x += UNIT) { for (var s = 0; s < SUBDIVS; s++) { var X = x + s * SUB; if (X < 0 || X > W) continue;
        ctx.strokeStyle = s === 0 ? 'rgba(' + FG + ',0.085)' : 'rgba(' + FG + ',0.028)'; ctx.lineWidth = 0.4;
        ctx.beginPath(); ctx.moveTo(X, 0); ctx.lineTo(X, H); ctx.stroke(); } }
      for (var y = -UNIT + baseY - oy; y < H + UNIT; y += UNIT) { for (var s2 = 0; s2 < SUBDIVS; s2++) { var Y = y + s2 * SUB; if (Y < 0 || Y > H) continue;
        ctx.strokeStyle = s2 === 0 ? 'rgba(' + FG + ',0.085)' : 'rgba(' + FG + ',0.028)'; ctx.lineWidth = 0.4;
        ctx.beginPath(); ctx.moveTo(0, Y); ctx.lineTo(W, Y); ctx.stroke(); } }
      ctx.font = '7px Helvetica'; ctx.fillStyle = 'rgba(' + FG + ',0.10)';
      for (var xn = -UNIT + (W / 2 % UNIT) - ox; xn < W + UNIT; xn += UNIT) { if (xn > 24 && xn < W - 20) ctx.fillText(Math.round((xn - W / 2 + (t * 8 % UNIT)) / UNIT * 10), xn + 2, 10); }
      for (var yn = -UNIT + baseY - oy; yn < H + UNIT; yn += UNIT) { if (yn > 12 && yn < H - 4) ctx.fillText(Math.round((yn + sy - H / 2 + (t * 5 % UNIT)) / UNIT * 10), 2, yn - 2); }
      ctx.strokeStyle = 'rgba(' + FG + ',0.14)'; ctx.lineWidth = 0.5;
      [[0, 20, W, 20], [20, 0, 20, H], [0, H - 20, W, H - 20], [W - 20, 0, W - 20, H]].forEach(function (a) { ctx.beginPath(); ctx.moveTo(a[0], a[1]); ctx.lineTo(a[2], a[3]); ctx.stroke(); });
      for (var xt = -UNIT + (W / 2 % UNIT) - ox; xt < W + UNIT; xt += UNIT) { if (xt < 0 || xt > W) continue; ctx.strokeStyle = 'rgba(' + FG + ',0.2)'; ctx.lineWidth = 0.5;
        ctx.beginPath(); ctx.moveTo(xt, 20); ctx.lineTo(xt, 29); ctx.stroke(); ctx.beginPath(); ctx.moveTo(xt, H - 20); ctx.lineTo(xt, H - 29); ctx.stroke(); }
      for (var yt = -UNIT + baseY - oy; yt < H + UNIT; yt += UNIT) { if (yt < 0 || yt > H) continue; ctx.strokeStyle = 'rgba(' + FG + ',0.2)'; ctx.lineWidth = 0.5;
        ctx.beginPath(); ctx.moveTo(20, yt); ctx.lineTo(29, yt); ctx.stroke(); ctx.beginPath(); ctx.moveTo(W - 20, yt); ctx.lineTo(W - 29, yt); ctx.stroke(); }
      var cx = W / 2, cy = H / 2 - sy, rgb = hlRGB();
      if (cy > -24 && cy < H + 24) {
        ctx.strokeStyle = 'rgba(' + rgb + ',0.5)'; ctx.lineWidth = 0.6;
        ctx.beginPath(); ctx.moveTo(cx - 18, cy); ctx.lineTo(cx + 18, cy); ctx.stroke();
        ctx.beginPath(); ctx.moveTo(cx, cy - 18); ctx.lineTo(cx, cy + 18); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx, cy, 4, 0, Math.PI * 2); ctx.strokeStyle = 'rgba(' + rgb + ',0.3)'; ctx.stroke();
      }
      ctx.fillStyle = 'rgba(' + FG + ',0.18)'; [[0, 0], [W, 0], [0, H], [W, H]].forEach(function (p) { ctx.beginPath(); ctx.arc(p[0], p[1], 2.5, 0, Math.PI * 2); ctx.fill(); });
      if (mx >= 0) { ctx.strokeStyle = 'rgba(' + rgb + ',0.22)'; ctx.lineWidth = 0.5; ctx.setLineDash([4, 7]);
        ctx.beginPath(); ctx.moveTo(mx, 0); ctx.lineTo(mx, H); ctx.stroke();
        ctx.beginPath(); ctx.moveTo(0, my); ctx.lineTo(W, my); ctx.stroke(); ctx.setLineDash([]);
        ctx.fillStyle = window.CRKD_HL || DEFAULT_HL; ctx.beginPath(); ctx.arc(mx, my, 2.5, 0, Math.PI * 2); ctx.fill(); }
    }
    var gridDirty = true;
    function loop() {
      if (!reduce) { t += 0.003; gridDirty = true; }
      if (gridDirty) { draw(); gridDirty = false; }
      if (antsOn) drawDoodle();
      requestAnimationFrame(loop);
    }

    /* ------------------------------------------------------------------
       3. mouse tracking — landing setReadout(), global
       ------------------------------------------------------------------ */
    var centers = $$('.j-coords');
    var readX = $$('.j-pX,.j-sX,.j-sx'), readY = $$('.j-pY,.j-sY,.j-sy');
    function setReadout(vx, vy) { var X = vx.toFixed(1), Y = vy.toFixed(1);
      centers.forEach(function (c) { c.textContent = 'X: ' + String(X).padStart(6) + '\u00a0\u00a0Y: ' + String(Y).padStart(6); });
      readX.forEach(function (el) { el.textContent = X; }); readY.forEach(function (el) { el.textContent = Y; }); }
    function clearReadout() { mx = -1; my = -1; gridDirty = true;
      centers.forEach(function (c) { c.textContent = 'X: \u2014\u2014\u00a0\u00a0Y: \u2014\u2014'; });
      readX.concat(readY).forEach(function (el) { el.textContent = '\u2014\u2014'; }); }
    var lastCX = -1, lastCY = -1;
    function track(cxp, cyp) {
      var r = grid.getBoundingClientRect();
      var x = cxp - r.left, y = cyp - r.top;
      if (cxp < 0 || x < 0 || y < 0 || x > r.width || y > r.height) { if (mx !== -1) clearReadout(); return; }
      mx = x; my = y; gridDirty = true;
      setReadout((mx - W / 2) / UNIT, (my + (window.scrollY || 0) - H / 2) / UNIT);
    }
    doc.addEventListener('mousemove', function (e) { lastCX = e.clientX; lastCY = e.clientY; track(lastCX, lastCY); }, { passive: true });
    window.addEventListener('scroll', function () { if (lastCX >= 0) track(lastCX, lastCY); }, { passive: true });
    doc.addEventListener('mouseleave', clearReadout);

    /* ------------------------------------------------------------------
       4. Swatches — mode + highlight
       ------------------------------------------------------------------ */
    function hexToRgb(h) { h = h.replace('#', ''); if (h.length === 3) h = h.replace(/./g, '$&$&');
      var n = parseInt(h, 16); return [(n >> 16) & 255, (n >> 8) & 255, n & 255]; }
    var curHL = DEFAULT_HL, curMode = 'dark';
    function invHex(h) { var c = hexToRgb(h); return '#' + c.map(function (v) { return ('0' + (255 - v).toString(16)).slice(-2); }).join(''); }
    function pushHL() {
      var eff = curHL, rgb = hexToRgb(eff).join(',');
      root.style.setProperty('--crkd-hl', eff); root.style.setProperty('--crkd-hl-rgb', rgb);
      window.CRKD_HL = eff; window.CRKD_HL_RGB = rgb; gridDirty = true;
    }
    function applyHL(hex, save) {
      hex = (hex || DEFAULT_HL).toLowerCase(); curHL = hex; pushHL();
      $$('.cx-sw', sw).forEach(function (b) { b.classList.toggle('active', b.getAttribute('data-hl') === hex); });
      var known = $$('.cx-sw[data-hl="' + hex + '"]', sw)[0];
      if (!known) $('.cx-sw.custom', sw).classList.add('active');
      $('.cx-hlhex', sw).textContent = hex.toUpperCase();
      $('.cx-hlname', sw).textContent = hex === DEFAULT_HL ? 'brand pink' : (known ? known.getAttribute('aria-label').toLowerCase() : 'custom');
      $('.cx-in-hl', sw).value = hex;
      if (save) { if (hex === DEFAULT_HL) sdel('localStorage', 'crkd:hl'); else sset('localStorage', 'crkd:hl', hex); }
    }
    function applyMode(mode, save) {
      curMode = mode === 'light' ? 'light' : 'dark';
      root.classList.toggle('cx-light', curMode === 'light'); pushHL(); readFG();
      $$('.cx-switch button', sw).forEach(function (b) { b.classList.toggle('on', b.getAttribute('data-mode') === curMode); });
      if (save) sset('localStorage', 'crkd:mode', curMode);
    }
    sw.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      if (b.hasAttribute('data-mode')) applyMode(b.getAttribute('data-mode'), true);
      else if (b.classList.contains('cx-reset')) { applyHL(DEFAULT_HL, true); applyMode('dark', true); }
      else if (b.getAttribute('data-hl') === 'custom') { var i = $('.cx-in-hl', sw); i.click(); }
      else if (b.hasAttribute('data-hl')) applyHL(b.getAttribute('data-hl'), true);
    });
    $('.cx-in-hl', sw).addEventListener('input', function (e) { applyHL(e.target.value, true); });
    applyHL(sget('localStorage', 'crkd:hl') || DEFAULT_HL, false);
    applyMode(sget('localStorage', 'crkd:mode') === 'light' ? 'light' : 'dark', false);

    /* ------------------------------------------------------------------
       5. Drawing tools
       ------------------------------------------------------------------ */
    var dctx = dood.getContext('2d');
    var DPR = 1, DW = 0, DH = 0;
    var KEY = 'crkd:doodle:' + location.pathname;
    var st = { tool: 'move', fg: '#ff2d78', bg: '#ffffff', size: 4, fill: false, fs: 32 };
    var objs = [], undoS = [], redoS = [], temp = null, sel = null, antsOn = false, antOff = 0;
    var NAMES = { move: 'Move', brush: 'Brush', eraser: 'Eraser', ellipse: 'Ellipse', rect: 'Rectangle', triangle: 'Triangle',
      'sel-ellipse': 'Elliptical Marquee', 'sel-rect': 'Rect Marquee', 'sel-triangle': 'Triangle Marquee', type: 'Type', eyedrop: 'Eyedropper' };
    var CURSORS = { brush: 'crosshair', eraser: 'cell', ellipse: 'crosshair', rect: 'crosshair', triangle: 'crosshair',
      'sel-ellipse': 'crosshair', 'sel-rect': 'crosshair', 'sel-triangle': 'crosshair', type: 'text', eyedrop: 'copy' };

    try { var saved = JSON.parse(sget('sessionStorage', KEY) || 'null'); if (saved && saved.length) objs = saved; } catch (e) {}
    try { var prefs = JSON.parse(sget('localStorage', 'crkd:tools') || 'null'); if (prefs) { st.fg = prefs.fg || st.fg; st.bg = prefs.bg || st.bg; st.size = +prefs.size || st.size; st.fill = !!prefs.fill; st.fs = +prefs.fs || st.fs; } } catch (e) {}

    var persistT;
    function persist() { clearTimeout(persistT); persistT = setTimeout(function () {
      if (!objs.length) { sdel('sessionStorage', KEY); return; }
      var j = JSON.stringify(objs); if (j.length < 2500000) sset('sessionStorage', KEY, j); }, 250); }
    function savePrefs() { sset('localStorage', 'crkd:tools', JSON.stringify({ fg: st.fg, bg: st.bg, size: st.size, fill: st.fill, fs: st.fs })); }

    function resizeDoodle() {
      DPR = Math.min(window.devicePixelRatio || 1, 2);
      DW = dood.offsetWidth; DH = dood.offsetHeight;
      dood.width = Math.round(DW * DPR); dood.height = Math.round(DH * DPR);
      drawDoodle();
    }
    function norm(o) { var x = o.w < 0 ? o.x + o.w : o.x, y = o.h < 0 ? o.y + o.h : o.y; return { x: x, y: y, w: Math.abs(o.w), h: Math.abs(o.h) }; }
    function shapePath(c, kind, o) { var n = norm(o); c.beginPath();
      if (kind === 'ellipse') c.ellipse(n.x + n.w / 2, n.y + n.h / 2, Math.max(n.w / 2, .5), Math.max(n.h / 2, .5), 0, 0, Math.PI * 2);
      else if (kind === 'rect') c.rect(n.x, n.y, n.w, n.h);
      else { c.moveTo(n.x + n.w / 2, n.y); c.lineTo(n.x + n.w, n.y + n.h); c.lineTo(n.x, n.y + n.h); c.closePath(); } }
    function strokePath(c, pts) { c.beginPath(); c.moveTo(pts[0][0], pts[0][1]);
      if (pts.length === 1) { c.lineTo(pts[0][0] + .01, pts[0][1]); return; }
      for (var i = 1; i < pts.length - 1; i++) { var mx2 = (pts[i][0] + pts[i + 1][0]) / 2, my2 = (pts[i][1] + pts[i + 1][1]) / 2; c.quadraticCurveTo(pts[i][0], pts[i][1], mx2, my2); }
      c.lineTo(pts[pts.length - 1][0], pts[pts.length - 1][1]); }
    function font(fs) { return '700 ' + fs + 'px "Helvetica Neue", Helvetica, Arial, sans-serif'; }
    function paint(c, o) {
      c.save();
      if (o.t === 'stroke') { c.globalCompositeOperation = o.erase ? 'destination-out' : 'source-over';
        c.strokeStyle = o.c; c.lineWidth = o.w; c.lineCap = 'round'; c.lineJoin = 'round'; strokePath(c, o.pts); c.stroke(); }
      else if (o.t === 'ellipse' || o.t === 'rect' || o.t === 'triangle') { shapePath(c, o.t, o);
        if (o.f) { c.fillStyle = o.c; c.fill(); } else { c.strokeStyle = o.c; c.lineWidth = o.lw; c.lineJoin = 'miter'; c.stroke(); } }
      else if (o.t === 'cut') { c.globalCompositeOperation = 'destination-out'; shapePath(c, o.k, o); c.fillStyle = '#000'; c.fill(); }
      else if (o.t === 'text') { c.fillStyle = o.c; c.font = font(o.fs); c.textBaseline = 'alphabetic'; c.fillText(o.s, o.x, o.y); }
      c.restore();
    }
    function drawDoodle() {
      var sy = window.scrollY || 0;
      dctx.setTransform(1, 0, 0, 1, 0, 0); dctx.clearRect(0, 0, dood.width, dood.height);
      dctx.setTransform(DPR, 0, 0, DPR, 0, -sy * DPR);
      for (var i = 0; i < objs.length; i++) paint(dctx, objs[i]);
      if (temp) paint(dctx, temp);
      var s = sel || (temp && temp.t === 'sel' ? temp : null);
      if (s) { antOff = (antOff + 0.35) % 8;
        dctx.save(); shapePath(dctx, s.k, s); dctx.lineWidth = 1 / 1; dctx.setLineDash([4, 4]);
        dctx.strokeStyle = '#000'; dctx.lineDashOffset = -antOff; dctx.stroke();
        dctx.strokeStyle = '#fff'; dctx.lineDashOffset = -antOff + 4; dctx.stroke(); dctx.restore(); }
      if (st.tool === 'move') {
        [hoverI, picked].forEach(function (i, k) { if (i < 0 || !objs[i] || (k === 0 && i === picked)) return;
          var b = bbox(objs[i]); dctx.save(); dctx.lineWidth = 1; dctx.setLineDash(k ? [] : [3, 3]);
          dctx.strokeStyle = window.CRKD_HL || DEFAULT_HL; dctx.strokeRect(b.x - 4, b.y - 4, b.w + 8, b.h + 8);
          if (k) { dctx.fillStyle = '#fff'; [[b.x - 4, b.y - 4], [b.x + b.w + 4, b.y - 4], [b.x - 4, b.y + b.h + 4], [b.x + b.w + 4, b.y + b.h + 4]].forEach(function (c) {
            dctx.fillRect(c[0] - 3, c[1] - 3, 6, 6); dctx.strokeRect(c[0] - 3, c[1] - 3, 6, 6); }); }
          dctx.restore(); });
      }
      placeCut();
    }
    var cutBtn = $('.cx-cut');
    function placeCut() {
      if (!sel) { cutBtn.classList.remove('show'); return; }
      var n = norm(sel), r = dood.getBoundingClientRect(), sy = window.scrollY || 0;
      var x = r.left + n.x + n.w + 6, y = r.top + n.y + n.h - sy + 6;
      x = Math.min(Math.max(x, r.left + 4), r.right - 70); y = Math.min(Math.max(y, r.top + 4), r.bottom - 26);
      cutBtn.style.left = x + 'px'; cutBtn.style.top = y + 'px'; cutBtn.classList.add('show');
    }
    function commit(o) { undoS.push(objs.slice()); if (undoS.length > 80) undoS.shift(); redoS = []; objs.push(o); persist(); drawDoodle(); }
    function undo() { if (!undoS.length) return false; picked = -1; hoverI = -1; redoS.push(objs.slice()); objs = undoS.pop(); persist(); drawDoodle(); return true; }
    function redo() { if (!redoS.length) return false; picked = -1; hoverI = -1; undoS.push(objs.slice()); objs = redoS.pop(); persist(); drawDoodle(); return true; }
    function clearAll() { if (!objs.length) return; undoS.push(objs.slice()); redoS = []; objs = []; setSel(null); persist(); drawDoodle(); }
    function setSel(s) { sel = s; antsOn = !!s; if (!s) drawDoodle(); }
    function cutSel() { if (!sel) return; commit({ t: 'cut', k: sel.k, x: sel.x, y: sel.y, w: sel.w, h: sel.h }); setSel(null); }

    /* tool switching */
    var rail = $('.cx-rail'), toolName = $('.cx-toolname');
    function setTool(name) {
      if (commitType) commitType();
      st.tool = name;
      $$('.tool[data-tool]', rail).forEach(function (b) { b.classList.toggle('on', b.getAttribute('data-tool') === name); b.setAttribute('aria-pressed', b.getAttribute('data-tool') === name ? 'true' : 'false'); });
      root.classList.toggle('cx-drawing', name !== 'move');
      dood.style.cursor = CURSORS[name] || '';
      if (toolName) toolName.textContent = NAMES[name] || name;
      if (name !== 'move' && name.indexOf('sel-') !== 0 && sel) setSel(null);
      if (name !== 'move') { picked = -1; hoverI = -1; dood.style.pointerEvents = ''; drawDoodle(); }
      if (typeof syncFS === 'function' && fsRange) syncFS();
    }
    function cycle(list) { var i = list.indexOf(st.tool); setTool(list[(i + 1) % list.length] ); }

    /* colour chips */
    var chipFg = $('.cx-chip.fg'), chipBg = $('.cx-chip.bg'), inFg = $('.cx-in-fg'), inBg = $('.cx-in-bg');
    function paintChips() { chipFg.style.background = st.fg; chipBg.style.background = st.bg; inFg.value = st.fg; inBg.value = st.bg; }
    chipFg.addEventListener('click', function () { inFg.click(); });
    chipBg.addEventListener('click', function () { inBg.click(); });
    inFg.addEventListener('input', function () { st.fg = inFg.value; paintChips(); savePrefs(); });
    inBg.addEventListener('input', function () { st.bg = inBg.value; paintChips(); savePrefs(); });
    function swapC() { var a = st.fg; st.fg = st.bg; st.bg = a; paintChips(); savePrefs(); }
    function resetC() { st.fg = '#ff2d78'; st.bg = '#ffffff'; paintChips(); savePrefs(); }
    $('.cx-chip-swap').addEventListener('click', swapC);
    $('.cx-chip-reset').addEventListener('click', resetC);

    /* size popover + fill toggle */
    var pop = $('.cx-sizepop'), range = $('#cx-size'), sizeV = $('.cx-sizev'), sizeBtn = $('.tool[data-act="size"]');
    function setSize(v) { st.size = Math.max(1, Math.min(60, Math.round(v))); range.value = st.size; sizeV.textContent = st.size; savePrefs(); }
    range.addEventListener('input', function () { setSize(+range.value); });
    function togglePop(force) { var open = force != null ? force : !pop.classList.contains('open');
      if (open) { var r = sizeBtn.getBoundingClientRect(); pop.style.left = (r.right + 8) + 'px'; pop.style.top = Math.max(44, r.top - 8) + 'px'; }
      pop.classList.toggle('open', open); sizeBtn.classList.toggle('lit', open); }
    doc.addEventListener('pointerdown', function (e) { if (pop.classList.contains('open') && !pop.contains(e.target) && !sizeBtn.contains(e.target)) togglePop(false); });
    var fillBtn = $('.tool[data-act="fill"]');
    function paintFill() { $('.cx-fillmark', fillBtn).setAttribute('opacity', st.fill ? '1' : '0');
      fillBtn.setAttribute('aria-pressed', st.fill ? 'true' : 'false'); fillBtn.setAttribute('data-tip', 'Shape fill: ' + (st.fill ? 'solid' : 'outline')); }

    /* save png */
    function savePNG() {
      var c = doc.createElement('canvas'); c.width = dood.width; c.height = dood.height;
      var x = c.getContext('2d'); x.fillStyle = getComputedStyle(doc.body).backgroundColor === 'rgba(0, 0, 0, 0)' ? getComputedStyle(root).backgroundColor : getComputedStyle(doc.body).backgroundColor; x.fillRect(0, 0, c.width, c.height);
      x.drawImage(grid, 0, 0, c.width, c.height); x.drawImage(dood, 0, 0);
      x.font = '700 ' + (10 * DPR) + 'px Helvetica, Arial, sans-serif'; x.fillStyle = 'rgba(' + FG + ',.35)';
      x.fillText('CRKD*arthouse — crkd.ca', 30 * DPR, c.height - 30 * DPR);
      var a = doc.createElement('a'); a.download = 'crkd-doodle.png';
      try { a.href = c.toDataURL('image/png'); doc.body.appendChild(a); a.click(); a.remove(); } catch (e) {}
    }

    rail.addEventListener('click', function (e) {
      var b = e.target.closest('.tool'); if (!b) return;
      var tool = b.getAttribute('data-tool'), act = b.getAttribute('data-act');
      if (tool) { setTool(tool); return; }
      if (act === 'new') clearAll();
      else if (act === 'undo') undo();
      else if (act === 'redo') redo();
      else if (act === 'save') savePNG();
      else if (act === 'size') togglePop();
      else if (act === 'fill') { st.fill = !st.fill; paintFill(); savePrefs(); }
    });

    /* tooltips */
    var tip = $('.cx-tip');
    rail.addEventListener('mouseover', function (e) { var b = e.target.closest('.tool'); if (!b) return;
      var r = b.getBoundingClientRect(), k = b.getAttribute('data-key');
      tip.innerHTML = ''; tip.appendChild(doc.createTextNode(b.getAttribute('data-tip') || ''));
      if (k) { var kb = doc.createElement('kbd'); kb.textContent = k; tip.appendChild(kb); }
      tip.style.top = (r.top + r.height / 2) + 'px'; tip.classList.add('show'); });
    rail.addEventListener('mouseout', function (e) { if (!e.relatedTarget || !rail.contains(e.relatedTarget) || !e.relatedTarget.closest('.tool')) tip.classList.remove('show'); });

    /* pointer drawing */
    function pt(e) { var r = dood.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top + (window.scrollY || 0)]; }
    var down = null;
    dood.addEventListener('pointerdown', function (e) {
      if (st.tool === 'move' || e.button > 0) return;
      e.preventDefault();
      var p = pt(e);
      if (st.tool === 'type') { startType(e, p); return; }
      if (st.tool === 'eyedrop') { pick(e); return; }
      try { dood.setPointerCapture(e.pointerId); } catch (er) {}
      down = { x: p[0], y: p[1] };
      if (st.tool === 'brush' || st.tool === 'eraser') temp = { t: 'stroke', pts: [p], c: st.fg, w: st.tool === 'eraser' ? st.size * 3 : st.size, erase: st.tool === 'eraser' };
      else if (st.tool.indexOf('sel-') === 0) { setSel(null); temp = { t: 'sel', k: st.tool.slice(4), x: p[0], y: p[1], w: 0, h: 0 }; antsOn = true; }
      else temp = { t: st.tool, x: p[0], y: p[1], w: 0, h: 0, c: st.fg, f: st.fill, lw: Math.max(1, st.size) };
      drawDoodle();
    });
    dood.addEventListener('pointermove', function (e) {
      if (!down || !temp) return;
      var evs = e.getCoalescedEvents ? e.getCoalescedEvents() : [e];
      if (temp.t === 'stroke') { evs.forEach(function (ev) { temp.pts.push(pt(ev)); }); }
      else { var p = pt(e), w = p[0] - down.x, h = p[1] - down.y;
        if (e.shiftKey) { var m = Math.max(Math.abs(w), Math.abs(h)); w = (w < 0 ? -1 : 1) * m; h = (h < 0 ? -1 : 1) * m; }
        temp.w = w; temp.h = h; }
      drawDoodle();
    });
    function endDraw() {
      if (!down || !temp) return;
      var o = temp; temp = null; down = null;
      if (o.t === 'sel') { if (Math.abs(o.w) > 3 && Math.abs(o.h) > 3) setSel(o); else setSel(null); return; }
      if (o.t !== 'stroke' && (Math.abs(o.w) < 2 || Math.abs(o.h) < 2)) { drawDoodle(); return; }
      if (o.t === 'stroke') o.pts = o.pts.map(function (q) { return [Math.round(q[0] * 10) / 10, Math.round(q[1] * 10) / 10]; });
      commit(o);
    }
    dood.addEventListener('pointerup', endDraw);
    dood.addEventListener('pointercancel', endDraw);
    cutBtn.addEventListener('click', cutSel);

    /* move tool — drag doodles / marquee contents; the page stays clickable everywhere else */
    var picked = -1, hoverI = -1, drag = null;
    var hctx = doc.createElement('canvas').getContext('2d');
    function bbox(o) {
      if (o.t === 'stroke') { var x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity, h = o.w / 2;
        o.pts.forEach(function (q) { x0 = Math.min(x0, q[0]); y0 = Math.min(y0, q[1]); x1 = Math.max(x1, q[0]); y1 = Math.max(y1, q[1]); });
        return { x: x0 - h, y: y0 - h, w: x1 - x0 + o.w, h: y1 - y0 + o.w }; }
      if (o.t === 'text') { hctx.font = font(o.fs); var tw = hctx.measureText(o.s).width; return { x: o.x, y: o.y - o.fs * 0.8, w: tw, h: o.fs }; }
      return norm(o);
    }
    function overlap(a, b) { return a.x < b.x + b.w && b.x < a.x + a.w && a.y < b.y + b.h && b.y < a.y + a.h; }
    function hitOne(o, x, y) {
      hctx.setTransform(1, 0, 0, 1, 0, 0);
      if (o.t === 'cut' || (o.t === 'stroke' && o.erase)) return false;
      if (o.t === 'stroke') { hctx.lineWidth = o.w + 10; hctx.lineCap = 'round'; hctx.lineJoin = 'round'; strokePath(hctx, o.pts); return hctx.isPointInStroke(x, y); }
      if (o.t === 'text') { var b = bbox(o); return x >= b.x - 4 && x <= b.x + b.w + 4 && y >= b.y - 4 && y <= b.y + b.h + 4; }
      shapePath(hctx, o.t, o); hctx.lineWidth = (o.lw || 1) + 10;
      return hctx.isPointInPath(x, y) || hctx.isPointInStroke(x, y);
    }
    function hitAt(x, y) { for (var i = objs.length - 1; i >= 0; i--) if (hitOne(objs[i], x, y)) return i; return -1; }
    function inSel(x, y) { if (!sel) return false; shapePath(hctx, sel.k, sel); return hctx.isPointInPath(x, y); }
    function clone(o) { return JSON.parse(JSON.stringify(o)); }
    function shift(o, dx, dy) { if (o.t === 'stroke') o.pts.forEach(function (q) { q[0] += dx; q[1] += dy; }); else { o.x += dx; o.y += dy; } }
    function groupFor(i) { // the object plus any later cuts / eraser strokes that bite into it
      var b = bbox(objs[i]), g = [i];
      for (var j = i + 1; j < objs.length; j++) { var o = objs[j]; if ((o.t === 'cut' || (o.t === 'stroke' && o.erase)) && overlap(bbox(o), b)) g.push(j); }
      return g; }
    function groupSel() { var sb = norm(sel), g = [];
      objs.forEach(function (o, j) { var b = bbox(o), cx = b.x + b.w / 2, cy = b.y + b.h / 2; if (cx >= sb.x && cx <= sb.x + sb.w && cy >= sb.y && cy <= sb.y + sb.h) g.push(j); });
      return g; }
    function moveBy(g, dx, dy, withSel) { g.forEach(function (j) { shift(objs[j], dx, dy); }); if (withSel && sel) { sel.x += dx; sel.y += dy; } }
    function beginMove(g, withSel) { undoS.push(objs.slice()); if (undoS.length > 80) undoS.shift(); redoS = [];
      objs = objs.slice(); g.forEach(function (j) { objs[j] = clone(objs[j]); }); return g; }
    function armCanvas(on) { var v = on ? 'auto' : ''; if (dood.style.pointerEvents !== v) dood.style.pointerEvents = v; dood.style.cursor = on ? 'move' : ''; }
    doc.addEventListener('pointermove', function (e) {
      if (st.tool !== 'move' || drag || e.pointerType === 'touch') return;
      var r = dood.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) { if (hoverI !== -1) { hoverI = -1; drawDoodle(); } armCanvas(false); return; }
      var p = pt(e), h = hitAt(p[0], p[1]), s2 = inSel(p[0], p[1]);
      armCanvas(h >= 0 || s2);
      if (h !== hoverI) { hoverI = h; drawDoodle(); }
    }, { passive: true });
    doc.addEventListener('pointerdown', function (e) { // click on the page (not a doodle) drops the pick
      if (st.tool === 'move' && e.target !== dood && picked >= 0 && !e.target.closest('.cx-rail,.cx-insp,.cx-pop,[data-cx-type],.insp')) { picked = -1; drawDoodle(); syncFS(); }
    }, true);
    dood.addEventListener('pointerdown', function (e) {
      if (st.tool !== 'move' || e.button > 0) return;
      var p = pt(e), h = hitAt(p[0], p[1]), g;
      if (sel && inSel(p[0], p[1])) { g = beginMove(groupSel(), true); drag = { g: g, x: p[0], y: p[1], sel: true }; picked = -1; }
      else if (h >= 0) { g = beginMove(groupFor(h), false); drag = { g: g, x: p[0], y: p[1], sel: false }; picked = h; fsSnap = false; syncFS(); }
      else { armCanvas(false); return; }
      e.preventDefault(); try { dood.setPointerCapture(e.pointerId); } catch (er) {}
      drawDoodle();
    });
    dood.addEventListener('pointermove', function (e) {
      if (!drag) return; var p = pt(e); moveBy(drag.g, p[0] - drag.x, p[1] - drag.y, drag.sel); drag.x = p[0]; drag.y = p[1]; drawDoodle();
    });
    function endMove() { if (!drag) return; drag = null; persist(); drawDoodle(); }
    dood.addEventListener('pointerup', endMove);
    dood.addEventListener('pointercancel', endMove);
    function nudge(dx, dy) {
      if (sel && st.tool === 'move') { var g = beginMove(groupSel(), true); moveBy(g, dx, dy, true); }
      else if (picked >= 0 && objs[picked]) { var g2 = beginMove(groupFor(picked), false); moveBy(g2, dx, dy, false); }
      else return false;
      persist(); drawDoodle(); return true;
    }
    function deletePicked() { if (picked < 0 || !objs[picked]) return false;
      undoS.push(objs.slice()); redoS = []; objs = objs.slice(); objs.splice(picked, 1); picked = -1; hoverI = -1; persist(); drawDoodle(); return true; }

    /* eyedropper */
    function toHex(r, g, b) { return '#' + [r, g, b].map(function (v) { return ('0' + v.toString(16)).slice(-2); }).join(''); }
    function cssToHex(c) { var m = c && c.match(/rgba?\(([^)]+)\)/); if (!m) return null; var p = m[1].split(/[ ,\/]+/).map(parseFloat);
      if (p.length > 3 && p[3] === 0) return null; return toHex(p[0] | 0, p[1] | 0, p[2] | 0); }
    function pick(e) {
      var r = dood.getBoundingClientRect(), px = Math.round((e.clientX - r.left) * DPR), py = Math.round((e.clientY - r.top) * DPR), hex = null;
      try { var d = dctx.getImageData(px, py, 1, 1).data; if (d[3] > 20) hex = toHex(d[0], d[1], d[2]); } catch (er) {}
      if (!hex) { dood.style.pointerEvents = 'none'; var el = doc.elementFromPoint(e.clientX, e.clientY); dood.style.pointerEvents = '';
        while (el && !hex) { var cs = getComputedStyle(el); hex = cssToHex(cs.backgroundColor); if (!hex && el.childNodes.length && el.textContent.trim()) hex = cssToHex(cs.color); el = hex ? el : el.parentElement; }
        if (!hex) hex = '#0a0a0a'; }
      st.fg = hex; paintChips(); savePrefs();
    }

    /* type tool — Helvetica Bold only */
    var commitType = null, liveType = null;
    /* text size control (Properties) — sets new text, the text being typed, or the picked text */
    var fsRange = $('.cx-fs-range', typeRow), fsNum = $('.cx-fs-num', typeRow), fsSnap = false;
    function showFS(v) { fsRange.value = v; fsNum.value = v; }
    function pickedText() { return st.tool === 'move' && picked >= 0 && objs[picked] && objs[picked].t === 'text'; }
    function applyFS(v, fromUser) {
      v = Math.max(8, Math.min(200, Math.round(+v || 32))); showFS(v);
      if (pickedText()) { if (!fsSnap) { beginMove([picked], false); fsSnap = true; } objs[picked].fs = v; persist(); drawDoodle(); }
      else { st.fs = v; savePrefs(); if (liveType) liveType.set(v); }
    }
    fsRange.addEventListener('input', function () { applyFS(fsRange.value); });
    fsNum.addEventListener('input', function () { if (fsNum.value !== '') applyFS(fsNum.value); });
    fsNum.addEventListener('keydown', function (e) { e.stopPropagation(); if (e.key === 'Enter') fsNum.blur(); });
    [fsRange, fsNum].forEach(function (el) { el.addEventListener('change', function () { fsSnap = false; if (liveType) liveType.inp.focus(); }); });
    function syncFS() { var on = pickedText(); typeRow.classList.toggle('live', on || st.tool === 'type'); showFS(on ? objs[picked].fs : st.fs); }
    function startType(e, p) {
      if (commitType) { commitType(); return; }
      var fs = st.fs, color = st.fg;
      var inp = doc.createElement('input'); inp.type = 'text'; inp.className = 'cx-typein'; inp.setAttribute('aria-label', 'Type text');
      inp.style.left = e.clientX + 'px'; inp.style.top = (e.clientY - fs * 0.85) + 'px'; inp.style.fontSize = fs + 'px'; inp.style.color = color;
      inp.style.height = Math.round(fs * 1.15) + 'px'; inp.size = 4;
      doc.body.appendChild(inp); liveType = { inp: inp, y: e.clientY, set: function (v) { fs = v; inp.style.fontSize = v + 'px'; inp.style.top = (this.y - v * 0.85) + 'px'; inp.style.height = Math.round(v * 1.15) + 'px'; } };
      setTimeout(function () { inp.focus(); }, 0);
      var done = false;
      function finish(keep) { if (done) return; done = true; commitType = null; liveType = null;
        var v = inp.value; inp.remove();
        if (keep && v.trim()) commit({ t: 'text', x: p[0] + 2, y: p[1], s: v, c: color, fs: fs }); }
      commitType = function () { finish(true); };
      inp.addEventListener('input', function () { inp.size = Math.max(4, inp.value.length + 1); });
      inp.addEventListener('keydown', function (ev) { ev.stopPropagation();
        if (ev.key === 'Enter') { ev.preventDefault(); finish(true); } else if (ev.key === 'Escape') { ev.preventDefault(); finish(false); } });
      inp.addEventListener('keypress', function (ev) { ev.stopPropagation(); });
      inp.addEventListener('blur', function (ev) { if (ev.relatedTarget && typeRow.contains(ev.relatedTarget)) { return; } finish(true); });
      typeRow.addEventListener('focusout', function refocus(ev) { if (!done && !(ev.relatedTarget && typeRow.contains(ev.relatedTarget))) { typeRow.removeEventListener('focusout', refocus); if (doc.activeElement !== inp) finish(true); } });
    }

    /* keyboard */
    window.addEventListener('keydown', function (e) {
      if (isTyping(e.target)) return;
      var k = e.key, mod = e.metaKey || e.ctrlKey;
      if (mod && (k === 'z' || k === 'Z')) {
        if (e.shiftKey ? redo() : undo()) e.preventDefault(); return;
      }
      if (mod && (k === 'y' || k === 'Y')) { if (redo()) e.preventDefault(); return; }
      if (mod || e.altKey) return;
      if ((k === 'Delete' || k === 'Backspace') && sel) { e.preventDefault(); cutSel(); return; }
      if ((k === 'Delete' || k === 'Backspace') && st.tool === 'move' && picked >= 0) { e.preventDefault(); deletePicked(); return; }
      if (/^Arrow/.test(k) && st.tool === 'move' && (picked >= 0 || sel)) { var n = e.shiftKey ? 10 : 1;
        if (nudge(k === 'ArrowLeft' ? -n : k === 'ArrowRight' ? n : 0, k === 'ArrowUp' ? -n : k === 'ArrowDown' ? n : 0)) e.preventDefault(); return; }
      if (k === 'Escape') { if (picked >= 0) { picked = -1; drawDoodle(); } if (sel) setSel(null); else if (st.tool !== 'move') setTool('move'); togglePop(false); return; }
      if (window.innerWidth <= 880) return;
      var l = k.toLowerCase();
      if (l === 'v') setTool('move');
      else if (l === 'b') setTool('brush');
      else if (l === 'e') setTool('eraser');
      else if (l === 'u') cycle(['ellipse', 'rect', 'triangle']);
      else if (l === 'm') cycle(['sel-rect', 'sel-ellipse', 'sel-triangle']);
      else if (l === 't') setTool('type');
      else if (l === 'i') setTool('eyedrop');
      else if (l === 'x') swapC();
      else if (l === 'd') resetC();
      else if (k === '[') setSize(st.size - (st.size > 10 ? 2 : 1));
      else if (k === ']') setSize(st.size + (st.size >= 10 ? 2 : 1));
      else return;
    });

    /* scroll / resize */
    window.addEventListener('scroll', function () { gridDirty = true; drawDoodle(); }, { passive: true });
    window.addEventListener('resize', function () { resizeGrid(); resizeDoodle(); gridDirty = true; });

    paintChips(); setSize(st.size); paintFill(); setTool('move'); syncFS();
    resizeGrid(); resizeDoodle(); draw();
    if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(drawDoodle);
    requestAnimationFrame(loop);
  }

  if (doc.readyState !== 'loading') boot(); else doc.addEventListener('DOMContentLoaded', boot);
})();
